// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IRpcContext } from "@lib/messaging/rpc/IRpcContext";

/**
 * Represents a method responsible for handling a RPC call.
 */
export type RpcCallback<TRpcContext extends IRpcContext> = (context: TRpcContext, ...args: any[]) => any;